import { ReactNode } from 'react';
import styled, { ColorsTypes } from 'styled-components';

import { Box } from 'components';

interface TooltipProps {
  children: ReactNode;

  bg?: ColorsTypes;
  color?: ColorsTypes;
  bold?: boolean;

  content?: ReactNode;
}

const TooltipBox = styled.div<{ bg: ColorsTypes; color: ColorsTypes; bold: boolean }>`
  background: ${({ theme, bg }) => theme.colors[bg]};
  color: ${({ theme, color }) => theme.colors[color]};
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  border-radius: 4px;
  display: none;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'regular')};

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${({ theme, bg }) => theme.colors[bg]};
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const TooltipWrapper = styled((props) => <Box {...props} />)`
  font-size: 0;
  &:hover {
    ${TooltipBox} {
      display: block;
    }
  }
`;

const Tooltip = ({ bg = 'primary_400', color = 'primary_contrast', bold = true, children, content }: TooltipProps) => {
  return (
    <TooltipWrapper flexShrink={0} position="relative">
      <TooltipBox bg={bg} color={color} bold={bold}>
        {content}
      </TooltipBox>
      {children}
    </TooltipWrapper>
  );
};

export default Tooltip;
